import config from "config/config";

export enum BrandEnum {
    BOLT = "bolt",
    HOPP = "hopp",
}

export class Brand {
    public static readonly DEFAULT_BRAND = BrandEnum.BOLT;

    // "help.*" hostnames serve the monolith (path-based routing, e.g. help.bolt.eu/webform).
    // "supportwebform.*" is apps/webform's own subdomain under the workspace migration
    // (see docs/migration-plan.md) — each migrated workspace app gets its own subdomain.
    private static readonly HOPP_HOSTNAMES = [
        "help.gethopp.com",
        "help.prelive.gethopp.com",
        "supportwebform.gethopp.com",
        "supportwebform.prelive.gethopp.com",
    ];

    public static getBrandFromUrl(hostname: string = window.location.hostname): BrandEnum {
        if (config.brandOverride) {
            return (
                {
                    bolt: BrandEnum.BOLT,
                    hopp: BrandEnum.HOPP,
                }[config.brandOverride] || Brand.DEFAULT_BRAND
            );
        }

        return Brand.HOPP_HOSTNAMES.includes(hostname) ? BrandEnum.HOPP : BrandEnum.BOLT;
    }
}
